import { closest } from './_closest';

function updateHoverState(el, isHover) {
  el.classList.toggle('hover', isHover);

  const parent = closest(el, 'js-hover-parent');
  if(parent) {
    parent.classList.toggle('hover-parent', isHover);
  }
}

function bindHover(el) {
  const isTouch = typeof hasTouchScreen === 'function' && hasTouchScreen();
  const enterEvent = isTouch ? 'touchstart' : 'mouseenter';
  const leaveEvent = isTouch ? 'touchend' : 'mouseleave';

  el.addEventListener(enterEvent, function() {
    updateHoverState(this, true);
  });
  el.addEventListener(leaveEvent, function() {
    updateHoverState(this, false);
  });
}

export function hover() {
  const hov = document.querySelectorAll('a, button, .hov');
  hov.forEach(bindHover);
}

export function hoverDynamic(el) {
  if(el) {
    bindHover(el);
  }
}
